import { render, staticRenderFns } from "./detailRecommandation.vue?vue&type=template&id=3465e658"
import script from "./detailRecommandation.vue?vue&type=script&lang=js"
export * from "./detailRecommandation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports